import React, { useState } from "react";
import PropTypes from "prop-types";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@material-ui/core";
import Icon from "components/common_components/Icon";
import Button from "components/common_components/Button";

function FormRowActions({ form, onAddVersion, onRollback }) {
    const [anchorEl, setAnchorEl] = useState(null);

    // Clicks inside the menu must not reach the row, which would open the form in edit mode
    const onOpenHandler = (e) => {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const onCloseHandler = (e) => {
        if (e) e.stopPropagation();
        setAnchorEl(null);
    };

    const onOptionClickHandler = (action) => (e) => {
        onCloseHandler(e);
        action(form);
    };

    return (
        <div className="actions">
            <Button small link onClick={onOpenHandler} title="Actions">
                <Icon name="vertical-dots" color="secondary" size="md" />
            </Button>
            <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={onCloseHandler} onClick={(e) => e.stopPropagation()}>
                <MenuItem onClick={onOptionClickHandler(onAddVersion)}>
                    <ListItemIcon>
                        <Icon name="add" color="secondary" size="sm" />
                    </ListItemIcon>
                    <ListItemText primary="Add new version" />
                </MenuItem>
                {form.isCurrent && (
                    <MenuItem onClick={onOptionClickHandler(onRollback)}>
                        <ListItemIcon>
                            <Icon name="restore" color="secondary" size="sm" />
                        </ListItemIcon>
                        <ListItemText primary="Rollback to previous version" />
                    </MenuItem>
                )}
            </Menu>
        </div>
    );
}

FormRowActions.propTypes = {
    form: PropTypes.shape({
        isCurrent: PropTypes.bool,
    }).isRequired,
    onAddVersion: PropTypes.func.isRequired,
    onRollback: PropTypes.func.isRequired,
};

export default FormRowActions;
